import MediaLoader from './MediaLoader';
import { isNil } from '../../../util/object';
import { isEmpty as isEmptyArray } from '../../../util/array';

import { TEST } from '../../../constants';
import RetryBackoffPolicy from './RetryBackoffPolicy';
import { inEpisodeFlow } from '../../routes/state-management/selectors';
import { getMaxEpisodeDurationInSeconds } from '../../shared/creative/state-management/selectors';
import { getContentByMediaId } from '../../../selectors/content';
import {
  getElementIdByContentId,
  getLayerById,
} from '../../../selectors/element';
import Layer from '../../../model/Layer';

class PrivateMediaLoaderFactory {
  mediaMap = null;

  constructor() {
    this.mediaMap = new Map();
  }

  // TODO use model objects not state
  getMediaLoaderFromMedia(
    creativeLayer,
    retryPolicy = RetryBackoffPolicy.policyLinearBackoff(),
  ) {
    const { media, mediaURL } = creativeLayer;
    if (isNil(media)) return null;

    const { mediaType, uploaded } = media;

    const canUseCors = uploaded;
    return this.getMediaLoaderFromURL(
      mediaURL,
      mediaType,
      retryPolicy,
      canUseCors,
    );
  }

  /**
   * @function getMediaLoaderFromURL
   * @param  {String} url
   * @param  {String} mediaType
   * @param  {boolean} useCors
   * @param  {RetryBackoffPolicy} retryPolicy
   * @return {MediaLoader}
   */
  getMediaLoaderFromURL(
    url,
    mediaType,
    retryPolicy = RetryBackoffPolicy.policyLinearBackoff(),
    useCors = false,
  ) {
    if (!url) return null;
    if (TEST) return new MediaLoader(url, mediaType, retryPolicy, useCors);

    const lookupId = url;

    // TODO: Make sure media is loadable.

    if (!this.mediaMap.has(lookupId)) {
      const newMediaLoader = new MediaLoader(
        url,
        mediaType,
        retryPolicy,
        useCors,
      );
      this.mediaMap.set(lookupId, newMediaLoader);
    } else {
      // TODO compare state/element/media/content and then re-generate if necessary
    }

    return this.mediaMap.get(lookupId);
  }
}

const MediaLoaderFactory = new PrivateMediaLoaderFactory();
export default MediaLoaderFactory;

export function loadMedia(mediaId, state) {
  const contentList = getContentByMediaId(state, mediaId);
  if (isEmptyArray(contentList)) {
    return Promise.reject(
      new Error(
        `Cannot get media loader for nil content with media id ${mediaId}`,
      ),
    );
  }

  // Get first content, we only need one
  const content = contentList[0];

  const elementId = getElementIdByContentId(state, content.contentId);
  if (isNil(elementId)) {
    return Promise.reject(
      new Error(
        `Cannot get media loader for nil element id with content id ${content}`,
      ),
    );
  }

  const layer = getLayerById(state, elementId);
  if (!Layer.isLayer(layer)) {
    return Promise.reject(
      new Error(`Cannot get layer with element id ${elementId}`),
    );
  }

  const creativeLayer = Layer.getCreativeLayer(layer);

  const mediaLoader = MediaLoaderFactory.getMediaLoaderFromMedia(
    creativeLayer,
    state,
  );
  if (isNil(mediaLoader)) {
    return Promise.reject(new Error(`Media Loader was null ${mediaId}`));
  }
  if (inEpisodeFlow(state)) {
    mediaLoader.maxDuration = getMaxEpisodeDurationInSeconds(state);
  }
  mediaLoader.shouldThrowErrorOnDurationExceeded = true;
  return mediaLoader.loadMetaData();
}
